import { MaterialId } from '@core/constants/Material';
import { BorderShapeId, CuttingShapeId } from '@core/constants/Shape';
import {
    IFormFieldMaterial,
    IFormFieldShape,
    IFormFieldShapeQuantities,
} from '../../../interfaces/Form';
import allMaterials, { getMaterialsWithExceptions } from './materialGroups';

export const fieldsCounterBarTrayMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(allMaterials,
            [
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Douglas,
                MaterialId.DouglasEngineered,
                MaterialId.DouglasRecycled,
                MaterialId.DouglasVeneer,
                MaterialId.Redcedar,
                MaterialId.RedcedarEngineered,
                MaterialId.RedcedarRecycled,
                MaterialId.RedcedarVeneer,
                MaterialId.Larch,
                MaterialId.LarchEngineered,
                MaterialId.LarchRecycled,
                MaterialId.LarchVeneer,
                MaterialId.Padouk,
                MaterialId.PadoukEngineered,
                MaterialId.PadoukRecycled,
                MaterialId.PadoukVeneer,
                MaterialId.Ipe,
                MaterialId.IpeRecycled,
                MaterialId.IpeEngineered,
                MaterialId.IpeVeneer,
                MaterialId.Poplar,
                MaterialId.PoplarRecycled,
                MaterialId.PoplarVeneer,
                MaterialId.PoplarEngineered,
                MaterialId.Garapa,
                MaterialId.SheetMetal,
                MaterialId.PlexiglassFluorescent,
                MaterialId.PlexiglassFrosted,
                MaterialId.PlexiglassMirror,
                MaterialId.PlexiglassTransparent,
                MaterialId.PlexiglassWhite,
                MaterialId.PolycarbonateOpaque,
                MaterialId.PolycarbonateTeinted,
                MaterialId.PolycarbonateTransparent,
                MaterialId.Pvc,
                MaterialId.PvcRigid,
            ]),
        required: true,
    },
};

export const fieldsCounterBarBorder: IFormFieldShape = {
    value   : undefined,
    options : [
        BorderShapeId.SquareStraightEdge,
        BorderShapeId.LiveEdge,
        BorderShapeId.StraightEdgeChamfer,
        BorderShapeId.StraightEdgeSoftened,
        BorderShapeId.RoundedQuarterCircle,
        BorderShapeId.RoundedHalfCircle,
        BorderShapeId.AirplaneWings,
    ],
    required: true,
};

export const fieldsCounterBarCutting: IFormFieldShapeQuantities = {
    [CuttingShapeId.IntegratedSink]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [CuttingShapeId.Drainer]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [CuttingShapeId.IntegratedAppliance]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
};

